import { Chart } from 'chart.js';
import { Icon } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: -35px;
  position: relative;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 127px;
  right: 127px;
`;

function getIcon(type) {
  switch (type) {
    case 'shoutout':
      return 'shoutoutOutline';

    case 'connect':
      return 'camera';

    case 'referral':
      return 'forwardToInbox';

    default:
  }
}

let myChart;
const CustomDonutChart = ({ data, setSelected, selected }) => {
  const [chartData, setChartData] = useState({});

  useEffect(() => {
    let newData = {
      labels: [],
      data: [],
      bgs: []
    };

    data.forEach((x) => {
      newData.labels.push(x.label);
      newData.data.push(x.total);
      newData.bgs.push(x.color);
    });

    setChartData(newData);
  }, [data]);

  useEffect(() => {
    if (!Object.keys(chartData)?.length) return;
    renderChart();

    return () => myChart.destroy();
  }, [chartData]);

  function onHover(e, items) {
    if (!items.length) return setSelected({ type: 'all', label: 'All' });

    setSelected(data[items[0].index]);
  }

  if (!data) return null;

  function renderChart() {
    const ctx = document.getElementById(`dashboard-donut`);

    myChart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: chartData.labels,
        datasets: [
          {
            data: chartData.data,
            backgroundColor: chartData.bgs,
            hoverOffset: 4,
            borderWidth: 0,
            borderColor: chartData.bgs,
            hoverBorderWidth: 10,
            hoverBorderRadius: 0,
            hoverBorderJoinStyle: 'round'
          }
        ]
      },
      options: {
        plugins: {
          legend: { display: false },
          tooltip: { display: false }
        },
        radius: '70%',
        cutout: '70%',
        onHover: onHover
      }
    });
  }

  return (
    <Wrapper>
      <canvas id={'dashboard-donut'} />
      <IconContainer>
        <Icon dimensions={44} type={getIcon(selected.type)} col={theme.GREY_40} />
      </IconContainer>
    </Wrapper>
  );
};

export default CustomDonutChart;
